<div class="channels-wrapper">
  @for (channel of channels; track $index) {
    <div
      [pTooltip]="extractChannelHandle(channel)"
      tooltipPosition="top"
      class="channel"
      [class.active]="selectedChannel && selectedChannel.id === channel.id"
      [class.error]="hasValidationErrors(channel)"
      [class.success]="isPostPublished(channel)"
      [class.failed]="isPostFailed(channel)"
      (click)="onChannelClick(channel)"
    >
      <div class="channel-content">
        <ly-channel-avatar [channel]="channel" size="small"></ly-channel-avatar>

        <h6 class="channel-name">{{ channel.subscriblyChannel?.name }}</h6>

        <div class="channel-actions">
          @if (hasValidationErrors(channel) && !isPostFailed(channel)) {
            <ly-icon size="24px" class="warning-icon" icon="warning"></ly-icon>
          }

          @if (isPostFailed(channel)) {
            <ly-icon
              size="24px"
              class="failed-icon"
              icon="warning"
              [pTooltip]="tooltipContent"
              tooltipPosition="top"
            >
              <ng-template #tooltipContent>
                <div class="tooltip-content">
                  <div class="tooltip-header">
                    <strong class="tooltip-title">Publishing Failed</strong>
                  </div>
                  <div class="tooltip-message">
                    {{ getLastStatusMessage(channel) }}
                  </div>
                </div>
              </ng-template>
            </ly-icon>
          }

          @if (isPostPublished(channel)) {
            <a
              [href]="postExternalLink(channel)"
              class="external-link"
              target="_blank"
            >
              <ly-icon icon="externalLink"></ly-icon>
            </a>
          } @else if (
            doddleStatus === EDoddleState.published ||
            doddleStatus === EDoddleState.failed
          ) {
            <!-- nothing -->
          } @else {
            <div class="slide-switch m-0">
              <input
                (change)="onChannelSelectionChange(channel)"
                [checked]="
                  isSelected(channel) || isToggled(channel) || isForced(channel)
                "
                [disabled]="disabled"
                type="checkbox"
                id="toggle-{{ channel.id }}"
                class="slide-input"
              />
              <label for="toggle-{{ channel.id }}" class="slide-label">
                <span class="slider"></span>
              </label>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
